import React, { useContext, useState } from "react";
import AssetType from "../Asset Type/AssetType";
import styles from "../Add Beneficiary/styles/AddNewAsset.module.css";
import AddAsset from "../Add Asset/AddAsset";
import { useRef } from "react";
import { useEffect } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
function AddNewAsset({ assets, onClick, alreadySelected }) {
  const [modal, setModal] = useState();
  const [options, showOptions] = useState(false);
  const wrapperRef = useRef(null);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddTrustee.AddNewAsset
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddTrustee.AddNewAsset);
  }, [websiteCurrentLang]);
  const handleElection = () => {
    // showOptions(false)
    return;
  };
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        event.target.innerText !== "OK"
      ) {
        showOptions(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  return (
    <div
      onClick={() => showOptions(!options)}
      ref={wrapperRef}
      className={styles.main}
    >
      <div className={styles.add_asset}>
        <div className={styles.plus} />
      </div>
      <div className={styles.add_new_asset_text}>
        {content.addNewAssetText2}
      </div>
      {options ? (
        <>
          <div onClick={(e) => e.stopPropagation()} className={styles.options}>
            <div
              style={{ width: "100%", height: "20px", position: "relative" }}
            >
              <div
                onClick={() => showOptions(false)}
                className={styles.close}
              />
            </div>
            <div
              onClick={() => {
                setModal(<AddAsset onClose={() => setModal(null)} />);
              }}
              className={`${styles.option_cell} ${styles.option_cell_add}`}
            >
              <div className={styles.add_asset}>
                <div className={styles.plus} />
              </div>
              {content.addNewAssetText2}
            </div>
            {assets
              ?.filter((e) => !alreadySelected.includes(e.asset_id))
              .map((asset) => {
                return (
                  <div
                    onClick={() => {
                      onClick(asset);
                      handleElection();
                    }}
                    className={styles.option_cell}
                  >
                    <AssetType
                      list={true}
                      key={asset.asset_id}
                      asset_type={asset.asset_type}
                      asset_name={asset.asset_name}
                      removable={false}
                    />
                  </div>
                );
              })}
          </div>
        </>
      ) : null}

      {/*
        The Add Asset modal hangs off the component, not off the dropdown.

        It used to be the last child of `.options`, which is
        `position: absolute; z-index: 2` -- a stacking context. A modal nested
        in one cannot climb out of it: its own `z-index: 60` only ranks it
        among `.options`' children, so every part of the trusted-advisor popup
        above z-index 2 -- its scroll marker, its dividers -- painted straight
        over the modal.

        Out here it ranks in the popup's own context, where 60 puts it above
        all of them. It also stops the modal being torn down the moment the
        dropdown closes, which is what used to happen: the list and the modal
        shared one conditional.

        The click guard is what the dropdown's own stopPropagation used to do
        for it -- without it every click inside the modal reaches the root
        div's onClick and toggles the list underneath.
      */}
      {modal && <div onClick={(e) => e.stopPropagation()}>{modal}</div>}
    </div>
  );
}

export default AddNewAsset;
